import * as React from "react";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { useLabels } from "../helpers/label-provider/use-labels.mjs";
const ComparisonImage = (props) => {
  const labels = useLabels();
  const { onRemoveButtonClick, image, button, removeButtonLabel, isDisabled } = props;
  return /* @__PURE__ */ React.createElement("div", { className: "product-comparison__item-image-container" }, /* @__PURE__ */ React.createElement(Anchor, { ...button, tabIndex: isDisabled ? -1 : void 0 }, /* @__PURE__ */ React.createElement(Image, { ...image, className: "product-comparison__item-image", width: 180 })), onRemoveButtonClick && /* @__PURE__ */ React.createElement("button", { className: "product-comparison__remove-btn", onClick: onRemoveButtonClick, type: "button", disabled: isDisabled }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#close-round", className: "product-comparison__remove-btn-icon" }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, removeButtonLabel || labels.get("remove"))));
};
export {
  ComparisonImage
};
